export const PAYMENT_AMOUNT_PRECISION = 2;
export var PaymentMethod;
(function (PaymentMethod) {
    PaymentMethod["PAYPAL"] = "paypal";
    PaymentMethod["STRIPE"] = "stripe";
    PaymentMethod["COINGATE"] = "coingate";
})(PaymentMethod || (PaymentMethod = {}));
import { isEmpty } from "lodash";
import { DEFAULT_LANGUAGE } from "../language";
import { toJSON } from "../utils";
export const DEFAULT_PRICE_NAME = "regular";
export class PaymentPrice {
    constructor(params) {
        var _a, _b;
        this.id = (params === null || params === void 0 ? void 0 : params.id) || DEFAULT_PRICE_NAME;
        this.info = {};
        if ((params === null || params === void 0 ? void 0 : params.info) && !isEmpty(params.info)) {
            this.info = params.info;
        }
        else {
            this.info[DEFAULT_LANGUAGE] = {
                name: DEFAULT_PRICE_NAME,
                description: "",
            };
        }
        this.price = (params === null || params === void 0 ? void 0 : params.price) || 0;
        this.start = Number((_a = params === null || params === void 0 ? void 0 : params.start) !== null && _a !== void 0 ? _a : 0);
        this.end = Number((_b = params === null || params === void 0 ? void 0 : params.end) !== null && _b !== void 0 ? _b : 9999999999999);
        this.max = (params === null || params === void 0 ? void 0 : params.max) || -1;
        this.sold = (params === null || params === void 0 ? void 0 : params.sold) || 0;
    }
    get json() {
        return toJSON(this);
    }
}
export class PaymentConfig {
    constructor(params) {
        this.prices =
            (params === null || params === void 0 ? void 0 : params.prices) && !isEmpty(params.prices)
                ? params.prices
                    .map((price) => new PaymentPrice(price))
                    .sort((a, b) => a.start - b.start)
                : [new PaymentPrice()];
        this.max = (params === null || params === void 0 ? void 0 : params.max) || -1;
    }
    get json() {
        return toJSON(this);
    }
    get defaultPrice() {
        try {
            // return this.prices[this.prices.length - 1]; // latest price
            // highest price
            return this.prices.sort((a, b) => b.price - a.price)[0];
        }
        catch (error) { }
        return this.prices[0];
    }
    get currentPrice() {
        try {
            if (this.prices.length == 1)
                return this.prices[0];
            const now = new Date().valueOf();
            const n = this.prices.length;
            for (let i = 0; i < n; i++) {
                const price = this.prices[i];
                if (price.start <= now && price.end > now) {
                    if (price.max == -1)
                        return price;
                    if (price.sold < price.max)
                        return price;
                    const _prices = this.prices.slice(i + 1);
                    return (_prices.find((_price) => _price.sold < _price.max) ||
                        this.defaultPrice);
                }
            }
        }
        catch (error) { }
        return this.defaultPrice;
    }
    get sold() {
        return this.prices.reduce((acc, cur) => (acc += cur.sold), 0);
    }
}
